<template>
	<a-modal wrap-class-name="modal-authorize" :width="424" :visible="value" :title="null" :footer="null"
		:centered="true" @cancel="onCancel">
		<div class="modal-content">
			<div class="modal-header">
				<img class="logo" src="../assets/img/logo.png" />
				<a class="modal-close" data-dismiss="modal" href="javascript:;" @click="onCancel"></a>
			</div>
			<div class="modal-body">
				<div class="modal-tabs tabs-3" v-if="AUTHORIZE_TYPE.RESET == type">
					<a href="javascript:;" class="active">{{ $t("retrievePassword") }}</a>
					<a href="javascript:;" @click="changeAuthorizeType(AUTHORIZE_TYPE.LOGIN_PASSWORD)">{{ $t("toLogin")
						}}</a>
				</div>
				<div class="modal-tabs tabs-4" v-else-if="AUTHORIZE_TYPE.REGISTER == type">
					<a href="javascript:;" class="active">{{ $t("registerAccounts") }}</a>
					<a href="javascript:;" @click="changeAuthorizeType(AUTHORIZE_TYPE.LOGIN_PASSWORD)">{{ $t("toLogin")
						}}</a>
				</div>
				<div class="modal-tabs tabs-1" v-else>
					<a href="javascript:;" :class="[AUTHORIZE_TYPE.LOGIN_PASSWORD == type ? 'active' : '']"
						@click="changeAuthorizeType(AUTHORIZE_TYPE.LOGIN_PASSWORD)">{{ $t("loginByAccounts") }}</a>
					<a href="javascript:;" :class="[AUTHORIZE_TYPE.LOGIN_CODE == type ? 'active' : '']"
						@click="changeAuthorizeType(AUTHORIZE_TYPE.LOGIN_CODE)">{{ $t("loginByCodes") }}</a>
				</div>
				<form class="form" @submit.prevent="onSubmit">
					<div class="form-group" v-if="[AUTHORIZE_TYPE.LOGIN_PASSWORD].includes(type)">
						<input :placeholder="this.$t('phoneText')" name="username" v-model.trim="formdata.username" />
					</div>
					<div class="form-group"
						v-if="[AUTHORIZE_TYPE.LOGIN_CODE, AUTHORIZE_TYPE.REGISTER, AUTHORIZE_TYPE.RESET].includes(type)">
						<input :placeholder="this.$t('phoneText')" name="phone" v-model.trim="formdata.phone" />
					</div>

					<ws-password v-if="[AUTHORIZE_TYPE.LOGIN_PASSWORD, AUTHORIZE_TYPE.REGISTER].includes(type)"
						v-model.trim="formdata.password" :placeholder="this.$t('passwordText')"></ws-password>

					<ws-password v-if="[AUTHORIZE_TYPE.REGISTER].includes(type)"
						v-model.trim="formdata.confirm_passowrd" :placeholder="this.$t('passwordText')"></ws-password>

					<ws-password v-if="[AUTHORIZE_TYPE.RESET].includes(type)" v-model.trim="formdata.npassword"
						:placeholder="this.$t('newPasswordText')"></ws-password>

					<ws-password v-if="[AUTHORIZE_TYPE.RESET].includes(type)" v-model.trim="formdata.confirm_npassowrd"
						:placeholder="this.$t('loginConfirmPsw')"></ws-password>

					<div class="form-group form-captcha" v-if="false">
						<input :placeholder="this.$t('picturesText')" name="imgcode" v-model.trim="formdata.imgcode" />
						<img src="" />
					</div>

					<div class="form-group"
						v-if="[AUTHORIZE_TYPE.REGISTER, AUTHORIZE_TYPE.LOGIN_CODE, AUTHORIZE_TYPE.RESET].includes(type)">
						<input :placeholder="this.$t('codeText')" name="code" v-model.trim="formdata.code" />
						<span class="msgcode" @click="getCode">{{ time > 0 ? time + $t('timeReminder') :
							this.$t('getCodeText') }}</span>
					</div>

					<div class="form-meta" v-if="[AUTHORIZE_TYPE.LOGIN_PASSWORD].includes(type)">
						<span style="flex: 1"></span>
						<a href="javascript:;" @click="changeAuthorizeType(AUTHORIZE_TYPE.RESET)">{{
							$t("forgetPassword") }}</a>
					</div>

					<div class="form-terms" v-if="[AUTHORIZE_TYPE.REGISTER].includes(type)">
						<!-- <input type="checkbox" v-model="formdata.agree" /> -->
						<img src="../assets/img/icon-checkbox-checked.png" v-if="formdata.agree"
							@click="formdata.agree = false" />
						<img src="../assets/img/icon-checkbox.png" v-else @click="formdata.agree = true" />
						<!-- <a-checkbox v-model="formdata.agree" style="margin-right: 4px;" /> -->
						{{ $t('agreement') }}
						<a href="/disclaimer" target="_blank">{{ $t('registerAgreement') }}</a>
					</div>
					<div class="form-action"
						v-if="[AUTHORIZE_TYPE.LOGIN_PASSWORD, AUTHORIZE_TYPE.LOGIN_CODE].includes(type)">
						<a-button :loading="loading" type="primary" html-type="submit">{{ $t('login') }}</a-button>
					</div>
					<div class="form-action" v-else-if="[AUTHORIZE_TYPE.REGISTER].includes(type)">
						<a-button :loading="loading" type="primary" html-type="submit">{{ $t('register') }}</a-button>
					</div>
					<div class="form-action" v-else-if="[AUTHORIZE_TYPE.RESET].includes(type)"><a-button
							:loading="loading" type="primary" html-type="submit">{{ $t('reset') }}</a-button></div>
					<div class="form-meta"
						v-if="[AUTHORIZE_TYPE.LOGIN_PASSWORD, AUTHORIZE_TYPE.LOGIN_CODE].includes(type)">
						<span style="flex: 1"></span>
						<a href="javascript:;" style="color: #ed4b65"
							@click="changeAuthorizeType(AUTHORIZE_TYPE.REGISTER)">{{ $t('newRegister') }}</a>
					</div>
				</form>
			</div>
		</div>
	</a-modal>
</template>

<script>
import { AUTHORIZE_TYPE } from '@/utils/constants.js';
import wsPassword from '@/components/wsPassword.vue';
const FORMDATA = {
	phone: '',
	username: '',
	password: '',
	confirm_passowrd: '',
	npassword: '',
	confirm_npassowrd: '',
	code: '',
	imgcode: '',
	// nickname: '',
	agree: false
};
export default {
	name: 'wsAuthorize',
	components: {
		wsPassword
	},
	props: {
		value: {
			type: Boolean
		},
		type: {
			type: [String, Number]
		}
	},
	data() {
		return {
			AUTHORIZE_TYPE,
			formdata: Object.assign({}, FORMDATA),
			time: 0,
			loading: false
		};
	},
	computed: {
		routeName() {
			return this.$route.name.toLowerCase();
		}
	},
	methods: {
		changeAuthorizeType(type) {
			this.$emit('update:type', type);
		},
		async getCode() {
			const { phone } = this.formdata;
			if (this.time > 0) {
				return false
			}
			if (!/^0[35789]{1}\d{8}$/.test(phone)) {
				return this.$message.error(this.$t('phoneFormatReminder'));
			}
			this.time = 60;
			const response = await this.$api.post('/web/send_sms', { phone });
			if (response && response.code == 200) {
				let timer = setInterval(() => {
					if (this.time-- < 1) {
						clearInterval(timer);
						this.time = 0;
					}
				}, 1000);
			}
		},
		onCancel() {
			this.formdata = Object.assign({}, FORMDATA);
			this.$emit('input', false);
		},
		async onSubmit() {
			const { phone, username, password, confirm_passowrd, npassword, confirm_npassowrd, code, imgcode, agree } = this.formdata;
			var url = '';
			var data = {};
			this.loading = true;
			switch (this.type) {
				case AUTHORIZE_TYPE.REGISTER:
					url = '/web/register';
					data = {
						phone,
						password,
						code
					};
					break;
				case AUTHORIZE_TYPE.RESET:
					url = '/web/reset_password';
					data = { phone, password: npassword, code };
					break;
				case AUTHORIZE_TYPE.LOGIN_PASSWORD:
					url = '/web/login';
					data = { username, password };
					break;
				case AUTHORIZE_TYPE.LOGIN_CODE:
					url = '/web/check_code';
					data = { phone, code };
					break;
			}
			if (this.type == AUTHORIZE_TYPE.REGISTER && !agree) {
				this.loading = false;
				this.$message.error(this.$t('agreementReadReminder'));
				return;
			}
			var errors = [];
			Object.keys(data).forEach(key => {
				if (key == 'phone') {
					data.phone || errors.push(this.$t('phoneText'));
					/^0[35789]{1}\d{8}$/.test(data.phone) || errors.push(this.$t('phoneFormatReminder'));
				} else if (key == 'username') {
					data.username || errors.push(this.$t('phoneNicknameReminder'));
				} else if (key == 'password') {
					data.password || errors.push(this.$t('passwordText'));
					if (this.type == AUTHORIZE_TYPE.REGISTER && password != confirm_passowrd) {
						errors.push(this.$t('passwordMatchReminder'));
					}
					if (this.type == AUTHORIZE_TYPE.RESET && npassword != confirm_npassowrd) {
						errors.push(this.$t('passwordMatchReminder'));
					}
				} else if (key == 'code') {
					/^\d{4}$/.test(data.code) || errors.push(this.$t('codeFormatReminder'));
				}
			});

			if (errors.length) {
				this.loading = false;
				this.$message.error(errors[0]);
				return;
			}

			const response = await this.$api.post(url, data).catch(e => {
				this.loading = false;
			});
			if (response && response.code == 200) {
				const { token, ...minfo } = response.data;
				this.$storage.set('token', token);
				this.$storage.set('minfo', minfo);
				if (location.hostname == 'fb.0ldy.com' && typeof fbq == 'function') {
					fbq('track', 'CompleteRegistration', { currency: 'USD', value: 1 });
				} else if (location.hostname == 'gg.0ldy.com' && typeof gtag == 'function') {
					gtag('event', 'conversion', { 'send_to': 'AW-16751945172/crxCCNK94tsZEIHJh8Iq' });
				} else if (location.hostname == 'gg1.0ldy.com' && typeof gtag == 'function') {
					gtag('event', 'conversion', { 'send_to': 'AW-16751945172/pH0ICMPonO4ZENTL-bM-' });
				} else if (location.hostname == 'ggtg.0ldy.com' && typeof gtag == 'function') {
					gtag('event', 'conversion', { 'send_to': 'AW-16752056980/2YetCK7jj-EZEJS1gLQ-' });
				}
				location.reload();
			}
		}
	}
};
</script>
